import { getTooltipAttributes } from "@common/contexts/Tooltip";
import { type WithChildren } from "@common/declarations";
import classNames from "classnames";
import React from "react";
import { HtmlLike } from "../component";

import "./style.less";

export type HintProps = React.HTMLProps<any> &
  Partial<WithChildren> & {
    hint?: any;
    className?: string;
    isSingleLine?: boolean;
    tooltip?: string;
    style?: React.CSSProperties;
  };

const Hint = ({ className, isSingleLine, style, ...props }: HintProps) => (
  <HtmlLike
    className={classNames("hint", className, {
      "single-line-ellipsis": isSingleLine
    })}
    style={style}
    tag="span"
    {...getTooltipAttributes(props.tooltip)}
    {...props}
  >
    {props.children ?? props.hint}
  </HtmlLike>
);
export default Hint;
